export const TimeEntryMirrorSignatureStatusConst = {
  PENDING: 1,
  SIGNED: 2,
};

export const TimeEntryMirrorSignatureStatusLabel: Record<number, string> = {
  [TimeEntryMirrorSignatureStatusConst.PENDING]: "Assinatura pendente",
  [TimeEntryMirrorSignatureStatusConst.SIGNED]: "Assinado",
};
